import React, { useEffect } from 'react';
import Styles from './errorPage.module.css';
import errorImg from './assets/error.png';
import { FooterComponent } from '../../components/common/footer/footer.component';
import { useHistory } from 'react-router';
import { history } from "../../history";

export const ErrorPage: React.FC<any> = props => {
	return (
		<div className={Styles.errorContainer}>
			<div className={Styles.errorBlock}>
				<div className={Styles.errorHeader}>
					<div className={Styles.errorIcon}>
						<img src={errorImg}></img>
					</div>
					<div className={Styles.title}>Error Loading Page</div>
				</div>
				<div className={Styles.errorBody}>
					<p>
						We have encountered an error loading the requested page. Please try to reload the page or
						contact your Financial Advisor.
					</p>
				</div>
				{/* <div className={Styles.errorBodyFooter}>
					<div className={Styles.backButton} onClick={(e) => {
						e.preventDefault();
						// history.goBack();
						window.history.back();
						}}>
						<span>Back</span>
					</div>
				</div> */}
			</div>
			<FooterComponent containerClass={Styles.footerStyle} />
		</div>
	);
};
